import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './Style.css';
import topwebdevelopmenttrends from './assets/topwebdevelopmenttrends.jpg';
import blogWebDev from './assets/WebDevelopment.jpg';
import blogGraphicDesign from './assets/graphic-design.avif';
import uiuxdesignprinciples from './assets/uiuxdesignprinciples.jpg';
import blogSocialMedia from './assets/social-media.avif';
import blogDigitalServices from './assets/digital-services.jpg';
import blogWebsiteDevelopmentImage from './assets/website-development.avif';
import blogAIMarketing from './assets/AIDigitalMarketing.jpg';
import blogTopRatedWebsiteDevelopmentCompanies from './assets/blogTopRatedWebsiteDevelopmentCompanies.jpg';
import ecommercewebsitesevelopment from './assets/ecommercewebsitesevelopment.jpg';
import bestplatformshiring from './assets/bestplatformshiring.jpg';


const Blog = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 2; // Show 2 blogs per page for demo

  const allBlogs = [
    {
      id: 1,
      title: 'Top Web Development Trends to Boost Your Business in 2025',
      excerpt: 'Discover the latest web development trends, including progressive web apps, AI integration, and responsive design, to enhance your online presence with DotLocalHost.',
      image: topwebdevelopmenttrends,
      path: '/blog:webdevelopment',
      category: 'Web Development',
      date: '1 Nov 2025',
      gradient: 'gradient-1'
    },
    {
      id: 2,
      title: 'Graphic Designing: Crafting Visuals That Captivate Your Audience',
      excerpt: 'Learn how professional graphic designing can elevate your brand with stunning visuals, from logos to social media graphics, with DotLocalHost.',
      image: blogGraphicDesign,
      path: '/blog:graphic-designing',
      category: 'Design',
      date: '1 Nov 2025',
      gradient: 'gradient-2'
    },
    {
      id: 3,
      title: 'Social Media Marketing for SEO: Strategies to Rank Higher',
      excerpt: 'Boost your website\'s SEO with social media marketing strategies that drive traffic and engagement, crafted by DotLocalHost.',
      image: blogSocialMedia,
      path: '/blog:social-media-marketing',
      category: 'Marketing',
      date: '1 Nov 2025',
      gradient: 'gradient-3'
    },
    {
      id: 4,
      title: 'Elevate Your Online Presence: Top Digital Services to Boost Your Business in 2025',
      excerpt: 'Explore DotLocalHost\'s digital services, including website development, eCommerce, PHP/Laravel, React, WordPress, graphic design, and social media management.',
      image: blogDigitalServices,
      path: '/blog:digital-services',
      category: 'Digital Services',
      date: '1 Nov 2025',
      gradient: 'gradient-4'
    },
    {
      id: 5,
      title: 'Complete Website Development Services: Build Your Online Presence - DotLocalHost',
      excerpt: 'website development services, web development company, custom website development, UI/UX design, front-end development, back-end development, eCommerce development, SEO optimization, WordPress development, website maintenance, Dubai web development',
      image: blogWebsiteDevelopmentImage,
      path: '/blog:website-development',
      category: 'Web Development',
      date: '15 Nov 2025',
      gradient: 'gradient-1'
    },
    {
      id: 6,
      title: 'React.js Best Practices for Modern Web Applications',
      excerpt: 'Learn the essential React.js best practices that will help you build scalable and maintainable web applications in 2025.',
      image: blogWebDev,
      path: '/blog:react-best-practices-for-modern-web-applications',
      category: 'Web Development',
      date: '15 Nov 2025',
      gradient: 'gradient-2'
    },
    {
      id: 7,
      title: 'UI/UX Design Principles for Better User Engagement',
      excerpt: 'Discover the key UI/UX design principles that can significantly improve user engagement and conversion rates for your website.',
      image: uiuxdesignprinciples,
      path: '/blog:ui-ux-principles',
      category: 'Design',
      date: '20 Nov 2025',
      gradient: 'gradient-3'
    },
    {
      id: 8,
      title: 'AI-Powered Digital Marketing Strategies to Scale Your Business in 2025',
      excerpt: 'Discover how AI-powered digital marketing strategies like automation, predictive analytics, and AI-driven SEO can help scale your business faster in 2025.',
      image: blogAIMarketing,
      path: '/blog:ai-digital-marketing-strategies-2025',
      category: 'Marketing',
      date: '10 Apr 2025',
      gradient: 'gradient-4'
    },
    {
      id: 9,
      title: 'Top-Rated Website Development Companies Near Me - DotLocalHost Blog',
      excerpt: 'Looking for top-rated website development companies near you? Discover how to choose the best web development agency for your business growth in 2025.',
      image: blogTopRatedWebsiteDevelopmentCompanies,
      path: '/blog:website-development-companies',
      category: 'Web Development',
      date: '04 Mar 2026',
      gradient: 'gradient-1'
    },
    {
      id: 10,
      title: 'Ecommerce Website Development Services in USA | Custom Online Store Solutions 2025',
      excerpt: 'Professional ecommerce website development services in USA. We build secure, SEO-optimized, high-converting online stores using Shopify, WooCommerce, Magento, and React.',
      image: ecommercewebsitesevelopment,
      path: '/blog:ecommerce-website-development-services',
      category: 'Web Development',
      date: '05 Mar 2026',
      gradient: 'gradient-2'
    },
    {
      id: 11,
      title: 'Ecommerce Website Development Services in USA | Custom Online Store Solutions 2025',
      excerpt: 'Professional ecommerce website development services in USA. We build secure, SEO-optimized, high-converting online stores using Shopify, WooCommerce, Magento, and React.',
      image: bestplatformshiring,
      path: '/blog:hiring-best-website-developers-platforms',
      category: 'Web Development',
      date: '06 Mar 2026',
      gradient: 'gradient-3'
    },

  ];

  // Filter blogs based on category
  // Filter blogs based on category
  const filteredBlogs =
    activeCategory === 'All'
      ? allBlogs
      : allBlogs.filter(blog => blog.category === activeCategory);

  // Pagination after filtering
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);


  // Pagination handlers
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <Helmet>
        <title>DotLocalHost Blog - Web Development, Graphic Design, SEO Tips</title>
        <meta
          name="description"
          content="Explore DotLocalHost's blog for insights on web development, graphic designing, and social media marketing for SEO. Boost your business today!"
        />
        <meta
          name="keywords"
          content="web development, graphic designing, social media marketing, SEO tips, Dubai web services, DotLocalHost blog"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://dotlocalhost.com/blog" />
      </Helmet>

      <div className="blog-page">
        <div className="blog-header">
          <h1>You might like</h1>
          <div className="search-filter-section">
            <h2>Search for a resource</h2>
            <div className="filter-tabs">
              {['All', 'Web Development', 'Design', 'Marketing', 'Digital Services'].map((category) => (
                <button
                  key={category}
                  className={`filter-tab ${activeCategory === category ? 'active' : ''}`}
                  onClick={() => {
                    setActiveCategory(category);
                    setCurrentPage(1); // Reset to first page on filter change
                  }}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="blog-list">
          {currentBlogs.map((blog) => (
            <div key={blog.id} className="blog-card-full">
              <div className="blog-image-container">
                <img src={blog.image} alt={blog.title} className="blog-image" />
                <div className="image-overlay"></div>
              </div>
              <div className={`blog-content-full ${blog.gradient}`}>
                <div className="blog-meta">
                  <span className="blog-date">{blog.date}</span>
                  <span className="blog-refresh">🔄 Radio Masho</span>
                </div>
                <div className="blog-category-tag">{blog.category}</div>
                <h2 className="blog-title">{blog.title}</h2>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <Link to={blog.path} className="read-more-btn">
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Component */}
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {indexOfFirstBlog + 1}-{Math.min(indexOfLastBlog, allBlogs.length)} of {allBlogs.length} articles
          </div>

          <div className="pagination">
            <button
              className={`pagination-btn prev ${currentPage === 1 ? 'disabled' : ''}`}
              onClick={prevPage}
              disabled={currentPage === 1}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6" />
              </svg>
              Previous
            </button>

            <div className="pagination-numbers">
              {Array.from({ length: totalPages }, (_, index) => {
                const pageNumber = index + 1;
                // Show first page, last page, current page, and pages around current page
                if (
                  pageNumber === 1 ||
                  pageNumber === totalPages ||
                  (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                ) {
                  return (
                    <button
                      key={pageNumber}
                      className={`pagination-number ${currentPage === pageNumber ? 'active' : ''}`}
                      onClick={() => goToPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  );
                } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
                  return <span key={pageNumber} className="pagination-ellipsis">...</span>;
                }
                return null;
              })}
            </div>

            <button
              className={`pagination-btn next ${currentPage === totalPages ? 'disabled' : ''}`}
              onClick={nextPage}
              disabled={currentPage === totalPages}
            >
              Next
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;